import { create } from 'zustand'

type ServerTimeStore = {
  serverOffsetMs: number
  lastSyncedAtMs: number | null
  setSynchronization: (offsetMs: number, syncedAtMs: number) => void
}

export const SERVER_TIME_CACHE_TTL_MS = 5 * 60 * 1000

// Смещение времени внешнего API относительно часов клиента (мс)
export const useServerTimeStore = create<ServerTimeStore>(set => ({
  serverOffsetMs: 0,
  lastSyncedAtMs: null,
  setSynchronization: (serverOffsetMs, lastSyncedAtMs) =>
    set({ serverOffsetMs, lastSyncedAtMs })
}))

export const getServerNow = () =>
  Date.now() + useServerTimeStore.getState().serverOffsetMs

let syncPromise: Promise<void> | null = null

export const syncServerTime = () => {
  if (syncPromise !== null) {
    return syncPromise
  }

  const monotonicNow = performance.now()
  const { lastSyncedAtMs } = useServerTimeStore.getState()

  if (
    lastSyncedAtMs !== null &&
    monotonicNow - lastSyncedAtMs < SERVER_TIME_CACHE_TTL_MS
  ) {
    return null
  }

  syncPromise = (async () => {
    const requestStartedAt = Date.now()
    const response = await fetch('/api/server-time', { cache: 'no-store' })

    if (!response.ok) {
      throw new Error('Server time is unavailable')
    }

    const { serverTime } = (await response.json()) as { serverTime: string }
    const responseReceivedAt = Date.now()
    const serverTimeMs = Date.parse(serverTime)

    if (!Number.isFinite(serverTimeMs)) {
      throw new TypeError('Invalid server time')
    }

    const clientMidpoint = (requestStartedAt + responseReceivedAt) / 2
    useServerTimeStore
      .getState()
      .setSynchronization(serverTimeMs - clientMidpoint, performance.now())
  })().finally(() => {
    syncPromise = null
  })

  return syncPromise
}
